import { Children, cloneElement, isValidElement } from 'react';
import { movementParticipantText } from '@/lib/movementParticipants';

const TEXT_PROPS = ['title', 'aria-label', 'placeholder', 'alt', 'label', 'emptyText', 'subtitle'];

function labelizeNode(node, movement) {
  if (typeof node === 'string') return movementParticipantText(node, movement);
  if (Array.isArray(node)) return node.map(child => labelizeNode(child, movement));
  if (!isValidElement(node)) return node;
  const nextProps = {};
  TEXT_PROPS.forEach(prop => {
    if (typeof node.props?.[prop] === 'string') nextProps[prop] = movementParticipantText(node.props[prop], movement);
  });
  if (node.props?.children) nextProps.children = Children.map(node.props.children, child => labelizeNode(child, movement));
  return cloneElement(node, nextProps);
}

export default function MovementLabelScope({ movement, children }) {
  return <>{Children.map(children, child => labelizeNode(child, movement || {}))}</>;
}